import { Navigate, Outlet } from 'react-router-dom'
import { Spinner, VStack } from '@chakra-ui/react'
import axios from 'axios'
import { useGrantSession } from '../../hooks/useGrantSession'
import { readGrantMirror } from '../../lib/grantMirror'

/**
 * Layout-route guard for /canvasser/* — UX-only. Every guarded server
 * endpoint is already `[Authorize(Policy = "GrantOnly")]`; this component
 * exists purely so a signed-out device lands on a friendly screen instead of
 * a blank/broken page. Source of truth is always /api/grant/me.
 */
export function RequireGrant() {
  const { identity, isLoading, isError, error } = useGrantSession()

  if (identity) return <Outlet />
  if (isLoading) return <VStack py={12}><Spinner size="lg" color="accent" /></VStack>

  // Offline (network error, not a 401) with a prior session mirror -> optimistic
  // entry so the existing offline walk-list keeps working without connectivity.
  // A real revoked/expired session surfaces as a 401, which carries a response
  // and is therefore NOT a network error.
  const isNetworkError = axios.isAxiosError(error) && !error.response
  if (isError && isNetworkError && readGrantMirror()) return <Outlet />

  return <Navigate to="/canvasser/redeem-needed" replace />
}
